// PC版追従ヘッダ内の宿泊予約ボタンのサブメニュー開閉
$('.js-submenu-toggle1').on('click', function () {
  $('.l-subheader.-restaurant').fadeOut(200);
  $('.l-subheader.-stay').fadeToggle(200);

  // メガメニューを閉じる
  $('nav.l-nav').removeClass('is-active').fadeOut(200);
  $('.js-toggleNav').removeClass('is-active');
});

// PC版追従ヘッダ内のレストラン予約ボタンのサブメニュー開閉
$('.js-submenu-toggle2').on('click', function () {
  $('.l-subheader.-stay').fadeOut(200);
  $('.l-subheader.-restaurant').fadeToggle(200);

  // メガメニューを閉じる
  $('nav.l-nav').removeClass('is-active').fadeOut(200);
  $('.js-toggleNav').removeClass('is-active');
});

// SP版画面下部固定メニュー内の宿泊予約ボタンのサブメニュー開閉
$('.js-fixedmenu-toggle1').on('click', function () {
  $(this).toggleClass('is-active');
  $('.fixedMenu').toggleClass('is-active');
  $('.fixedMenu-reservation.-restaurant').fadeOut(200);
  $('.fixedMenu-reservation.-stay').fadeToggle(200);

  // ボタンの排他制御
  btnExclusive();
  $('.js-fixedmenu-toggle2').removeClass('is-active');
});

// SP版画面下部固定メニュー内のレストラン予約ボタンのサブメニュー開閉
$('.js-fixedmenu-toggle2').on('click', function () {
  $(this).toggleClass('is-active');
  $('.fixedMenu').toggleClass('is-active');
  $('.fixedMenu-reservation.-stay').fadeOut(200);
  $('.fixedMenu-reservation.-restaurant').fadeToggle(200);

  // ボタンの排他制御
  btnExclusive();
  $('.js-fixedmenu-toggle1').removeClass('is-active');
});

// SP版画面下部固定メニューのボタン排他制御
function btnExclusive() {
  // グロナビを閉じる
  $('.l-header').removeClass('fixed');
  $('.js-toggleNav').removeClass('is-active');
  $('nav.l-nav').removeClass('is-active').fadeOut(200);
}